import React, { useRef} from 'react';
import './player.css';
import {BsFillPlayCircleFill, BsFillPauseCircleFill, BsFillSkipStartCircleFill, BsFillSkipEndCircleFill} from 'react-icons/bs';
// import { toBePartiallyChecked } from '@testing-library/jest-dom/dist/matchers';
// BsSkipEndCircleFill not available I think

const  hideAudioPlayer = () => {
  document.querySelector(".player_container").style.display = "none";
  document.querySelector("player_container").style.visibility = "hidden";
}


const Player = ({audioElem, isplaying, setisplaying, currentSong, setCurrentSong, songs})=> {

const clickRef = useRef();
  const PlayPause = ()=>
  {
    setisplaying(!isplaying);
    isplaying ? <BsFillPauseCircleFill className='btn_action pp' /> : <BsFillPlayCircleFill className='btn_action pp' />
    
  }
  const checkWidth = (e)=>
  {
    let width = clickRef.current.clientWidth;
    const offset = e.nativeEvent.offsetX;

    const divprogress = offset / width * 100;
    audioElem.current.currentTime = divprogress / 100 * currentSong.length;

  }
  BsFillPlayCircleFill.color = 'white'

  const skipBack = ()=>
  {
    const index = songs.findIndex(x=>x.title === currentSong.title);
    if (index === 0)
    {
      setCurrentSong(songs[songs.length - 1])
      setisplaying(!isplaying)
      isplaying ? <BsFillPlayCircleFill className='btn_action pp' /> : <BsFillPauseCircleFill className='btn_action pp' />
      audioElem.current.play();

    }
    else
    {
      setCurrentSong(songs[index - 1])
      setisplaying(!isplaying)
      isplaying ? <BsFillPlayCircleFill className='btn_action pp' /> : <BsFillPauseCircleFill className='btn_action pp' />
      audioElem.current.play();
      // audioElem.current.currentTime = 0;
    }
    audioElem.current.currentTime = 0;
    
  }


  const skiptoNext = ()=>
  {
    const index = songs.findIndex(x=>x.title === currentSong.title);
    if (index === songs.length-1)
    {
      setCurrentSong(songs[0])
      setisplaying(!isplaying)
      isplaying ? <BsFillPlayCircleFill className='btn_action pp' /> : <BsFillPauseCircleFill className='btn_action pp' />
      audioElem.current.currentTime = 0;
      audioElem.current.play();
      // audioElem.current.currentTime = 0;
    }
    else
    {
      setCurrentSong(songs[index + 1])
      setisplaying(!isplaying)
      isplaying ? <BsFillPlayCircleFill className='btn_action pp' /> : <BsFillPauseCircleFill className='btn_action pp' />
      audioElem.current.currentTime = 0;
      audioElem.current.play();
    }
  audioElem.current.currentTime = 0;
    
  }






  return (
    <div className='player_container '  >
      {/* <button class="btn audioClose" onClick={hideAudioPlayer} style ={btnStyle }><i class="fa fa-close2 btn_action"></i></button> */}
      <button  className="btn-close " onClick={hideAudioPlayer} ><i class="fa fa-close"></i>
</button>
      <div className="title" >
        <p className='songTitle'>{currentSong.title}</p>
      </div>
      <div className="navigation">
        <div className="navigation_wrapper" onClick={checkWidth} ref={clickRef}>
          <div className="seek_bar" style={{width: `${currentSong.progress+"%"}`}}></div>
        </div>
      </div>
      <div className="controls btnControls">
        <BsFillSkipStartCircleFill className='btn_action' onClick={skipBack}/>
        {isplaying ? <BsFillPauseCircleFill className='btn_action pp' onClick={PlayPause}/> : <BsFillPlayCircleFill className='btn_action pp' onClick={PlayPause}/>}
        <BsFillSkipEndCircleFill className='btn_action' onClick={skiptoNext}/>        
      </div>
    </div>
  
  )
}

export default Player